@if (label) {
  <label style="position:relative;">{{label}}@if (required) {
    <span class="label-required"></span>
  }</label>
}
<button class="select-many-search-component-button" type="button" [matMenuTriggerFor]="selectManyMenu" (menuOpened)="menuOpened();"
  (menuClosed)="menuClosed()" [disabled]="disabled && !value?.length"
  [class.no-label]="!label" [class.empty]="!value?.length" [class.disabled]="disabled"  [ngClass]="classes"
  #menuTrigger="matMenuTrigger">
  <div class="select-many-search-component-trigger"
       [ngClass]="{'placeholder-text': selectedTriggerText===placeholderText || selectedTriggerText==='Open to view selected'}">{{selectedTriggerText}}
  </div>
  <div class="mat-select-arrow-wrapper">
    <div class="mat-select-arrow"></div>
  </div>
</button>

<mat-menu #selectManyMenu="matMenu" hasBackdrop="true" class="select-many-menu-panel">
  <div (click)="$event.stopPropagation();">
    <option-list-search (keydown.space)="$event.stopPropagation()"
      [placeholder]="placeholder || 'Search'"
      (inputChanged)="filterOptions($event)"
      (inputCleared)="clearSearch()"
      [allowAccountSelection]="allowAccountSelection"
      [accountIds]="allowedAccountIds"
      (relayAccountsSelected)="onAccountsChanged($event)"
      [delay]="300">
    </option-list-search>

    <div class="row" style="justify-content: space-between;" (click)="$event.stopPropagation()">
      <div class="row_container">
        <h2>
          <div>Selected ({{sapi.selectedTotal}})</div>
          <mat-checkbox [(ngModel)]="sapi.keep_selected" (ngModelChange)="updateSearchSelected()"
            matTooltip="Show ALL items that are currently selected when searching"
            style="font-size:1.1rem;font-weight:500;">Show all when searching
          </mat-checkbox>
        </h2>
        <label style="margin-bottom:4px;">Showing {{selectedItems?.length}}</label>
        <div class="select-many-list-container"
          [items_loaded]="selectedItems?.length" [total_items]="sapi.selectedTotal" [threshold]="'50%'"
          (infiniteScroll)="getNextSelected()" [complete]="!sapi.loadNextSelected" msDivInfiniteScroll>
          <div id="selectedList"
            #selectedList="cdkDropList"
            (cdkDropListDropped)="drop($event)"
            [cdkDropListConnectedTo]="[availableList]"
            [cdkDropListData]="selectedItems"
            [cdkDropListDisabled]="disabled"
            cdkDropList
            class="select-many-list">
            @for (option of selectedItems; track option) {
              <div cdkDrag class="select-many-item"
                style="justify-content: space-between;padding-right:0;" [cdkDragDisabled]="disable_items">
                <div>
                  <div [matTooltip]="option['text']" [matTooltipShowDelay]="tooltipShowDelay"
                    class="option-text" [dblClickCopy]="option.value?.attributes?.name || option.text">{{option.text}}
                  </div>
                  @if (option.value?.attributes?.account_name) {
                    <div
                      class="account-name select-item-account-name"
                      [matTooltip]="option.value.attributes.account_name.trim()"
                      [matTooltipShowDelay]="tooltipShowDelay"
                      >
                      <div>{{option.value.attributes.account_name.trim()}}</div>
                    </div>
                  }
                </div>
                <button class="move" (click)="move(option, availableList, selectedList);"
                  [disabled]="disabled || disable_items || (removeItemDisabled?removeItemDisabled(option?.value):false)">
                  <i class="fa fa-caret-right"></i></button>
                </div>
              }

              <div class="stage-item stage" [hidden]="!sapi.loadingSelected">
                <div class="dot-flashing"></div>
              </div>

            </div>
          </div>
        </div>

        <div class="column move-all-buttons" style="margin:52px 4px;cursor:pointer;">
          <button mat-flat-button (click)="moveColumns('select')"
                  [disabled]="selectAllDisabled()"><i
                  class="fas fa-angle-double-left" matTooltip="Select all loaded columns"
                  [class.flashing-icon]="isSelecting"
          ></i></button>

        <button mat-flat-button (click)="moveColumns('remove')"
                [disabled]="removeAllDisabled()"><i
                class="fas fa-angle-double-right" matTooltip="Remove all loaded columns"
                [class.flashing-icon]="isRemoving"
        ></i></button>
        </div>

        <div class="row_container">
          <h2>Available ({{sapi.availableTotal}})</h2>
          <label style="margin-bottom:4px;">Showing {{availableItems?.length}}</label>
          <div class="select-many-list-container"
            [items_loaded]="availableItems?.length" [total_items]="sapi.availableTotal" [threshold]="'50%'"
            (infiniteScroll)="getNextAvailable()" [complete]="!sapi.loadNext" msDivInfiniteScroll>
            <div id="availableList"
              #availableList="cdkDropList"
              (cdkDropListDropped)="drop($event)"
              [cdkDropListConnectedTo]="[selectedList]"
              [cdkDropListData]="availableItems"
              [cdkDropListDisabled]="disabled"
              cdkDropList
              class="select-many-list">
              @for (option of availableItems; track option) {
                <div cdkDrag class="select-many-item"
                  [cdkDragDisabled]="disable_items">
                  <button class="move" (click)="move(option, selectedList, availableList);"
                    [disabled]="disabled || disable_items">
                    <i class="fa fa-caret-left"></i></button>
                    <div>
                      <div [matTooltip]="option['text']" [matTooltipShowDelay]="tooltipShowDelay"
                        class="option-text" [dblClickCopy]="option.value?.attributes?.name || option.text">{{option.text}}
                      </div>
                      @if (option.value?.attributes?.account_name) {
                        <div
                          class="account-name select-item-account-name"
                          [matTooltip]="option.value.attributes.account_name.trim()"
                          [matTooltipShowDelay]="tooltipShowDelay"
                          >
                          <div>{{option.value.attributes.account_name.trim()}}</div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (!sapi.loadingAvailable && !availableItems?.length && !selectedItems?.length) {
                  <div
                    >{{noItemsAvailableMessage}}
                  </div>
                }
                <div class="stage-item stage" [hidden]="!sapi.loadingAvailable">
                  <div class="dot-flashing"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </mat-menu>
